import { createFileRoute } from '@tanstack/react-router';
import { ScrollArea } from '~/primitives/scroll-area';
import { RolesTable } from './-RolesTable';
import { rolesQuery } from '~/util/queries/public/users';
import { requireScope } from '~/auth/utils';

export const Route = createFileRoute('/_authenticated/staff/roles')({
    beforeLoad: async ({ context: { auth } }) => {
        requireScope(auth, 'role_assign');
    },
    loader: async ({ context: { queryClient } }) =>
        await queryClient.fetchQuery(rolesQuery()),
    component: Roles,
    pendingMs: 3000,
});

function Roles() {
    return (
        <main className="h-full flex justify-center">
            <div className="flex flex-col p-4 gap-4 size-full bg-background-dark rounded-2xl">
                <ScrollArea className="w-full lg:h-[calc(100vh-150px)]">
                    <h1 className="text-secondary-foreground">Roles</h1>
                    <RolesTable />
                </ScrollArea>
            </div>
        </main>
    );
}
